'use client'

import type { BannerButtonProps } from '@maestro/commerce-blocks/components/banner/banner.types'

import React, { type PropsWithChildren } from 'react'

import { Button as UiButton } from '@pearlconvert/ui/components/button'
import { useModalLink } from '@pearlconvert/ui/hooks/use-modal-link'

export default function BannerButton(
  props: BannerButtonProps & PropsWithChildren
) {
  const { ariaLabel, children } = props
  const { url } = useModalLink({ url: props.url })
  return (
    <UiButton
      type="primary"
      size="large"
      className="banner__button"
      url={url}
      ariaLabel={ariaLabel}
    >
      {children}
    </UiButton>
  )
}
